import React, { useEffect, useState } from "react";

// Components
import Modal from "../Modal";

const ModalWaitingAction = (props) => {
  let props_temp = {small: true}
  if(props.secondButton == true){
    props_temp = {medium: true}
  }
  return (
    <Modal isVisible={props.showModalInfoAction} {...props_temp}>
      <p className="o-text-align--center">{props.text}</p>
      <div className="c-modal__buttons-wrapper">
      </div>
    </Modal>
  );
};

export default ModalWaitingAction;
